module.exports = __webpack_public_path__ + "web/img/type-4.3c7d9748.png";